import { Column } from "primereact/column";
import { InspectionsTableFields } from "../inspections-table/Fields";
import { MultiSelectTemplate, RowWithSubtext } from "@idwal/idwal-react-components";
import { InProgressTableRow } from "../inprogress-table/InProgressTable";
import { VESSEL_AND_IMO_FILTER_FIELD } from "../inspections-table/FilterFields";
import { useTranslation } from "react-i18next";

export const vesselColumn = (field: string, bodyTemplate: any) => {
    const { t } = useTranslation("locale");

    return <Column
        field={field}
        header={t("inspections.table.vesselHeader")}
        body={bodyTemplate}
        filter
        filterField={VESSEL_AND_IMO_FILTER_FIELD}
        filterPlaceholder={t("inspections.table.vesselFilter")}
        sortable
        frozen
    />
}

export const inspectionTypeColumn = (distinctTypes: string[]) => {
    const { t } = useTranslation("locale");

    return <Column
        field={InspectionsTableFields.INSPECTION_TYPE}
        header={t("inspections.table.typeHeader")}
        body={(data: InProgressTableRow) =>  RowWithSubtext(data, InspectionsTableFields.INSPECTION_TYPE, InspectionsTableFields.INSPECTION_NUMBER)}
        filter
        showFilterMenu={false}
        filterElement={(options) => MultiSelectTemplate(options, distinctTypes, t("inspections.table.showAll"), "inspection-type-filter")}
        sortable
    />
}

export const vesselTypeColumn = (field: string, distinctVesselTypes: string[]) => {
    const { t } = useTranslation("locale");

    return <Column
        field={field}
        header={t("inspections.table.vesselTypeHeader")}
        filter
        showFilterMenu={false}
        filterElement={(options) => MultiSelectTemplate(options, distinctVesselTypes, t("inspections.table.showAll"), "vessel-type-filter")}
        sortable
    />
}

export const inspectionDateColumn = (field: string, filterField: string, bodyTemplate: any, filterOptions: string[]) => {
    const { t } = useTranslation("locale");

    return <Column
        field={field}
        header={t("inspections.table.dateHeader")}
        body={bodyTemplate}
        filter
        filterField={filterField}
        showFilterMenu={false}
        filterElement={(options) => MultiSelectTemplate(options, filterOptions, t("inspections.table.showAll"), "inspection-date-filter")}
        sortable
    />
}
